import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import StyledButton from "../../../../common/models/Button";

import { appUrl } from "../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "650px",
  },
  resetChangesButton: {
    border: "1px solid #000000",
    color: "#000000",
    fontWeight: 600,
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    marginTop: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  backButton: {
    backgroundColor: "#555",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  // iconBtn: {
  //   padding: 6,
  //   color: "#000",
  // },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "2px",
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  saveButton: {
    backgroundColor: "#f26522",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#d4551a",
    },
  },
}));

const BatchStatusTab = (props) => {
  const { featuresAccess, sponsorId } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isUpdated, setIsUpdated] = useState(false);
  const [savingStates, setSavingStates] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const [batchStatuses, setBatchStatuses] = useState([]);
  
  
  const canEdit = featuresAccess?.editSponsorNetworkDetails ?? false;

  // Call fetchBatchStatuses on component mount

  const fetchBatchStatuses = async () => {
    setError(null);
    setLoading(true);

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFGStatuses/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;

      //console.log("API Batch Status Data:", data);

      if (response.data?.status === true || response.data?.status === "true") {
        const list = data?.batchStatuses || [];

        // Map the API response to match the expected structure
        const formattedStatuses = list.map((item, index) => ({
          id: item.status_id || `ID-${index + 1}`,
          name: item.status_name || "",
          selected: !!item.activated,
          isNew: false,
          type: item.status_type,
          newName: item.newStatusName,
        }));

        setBatchStatuses(formattedStatuses);
      } else {
        console.error(
          "Failed to fetch batch statuses:",
          response.data?.message
        );
        setError(response.data?.message || "Failed to fetch batch statuses.");
      }
    } catch (error) {
      console.error("Error fetching batch statuses:", error);
      setError("An error occurred while fetching batch statuses.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBatchStatuses();
  }, []);

  const addSASLBatchStatuses = async (index) => {
    const statusToAdd = batchStatuses[index]; // Get the status to add
    if (!statusToAdd.name?.trim() || savingStates[index]) return;
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    try {
      // Prepare the payload for the API
      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),
        saslBatchStatusesList: [
          {
            //status_id: statusToAdd.id , // Use the ID if available, otherwise null
            status_name: statusToAdd.name, // Name of the Batch status
            status_type: "New", // Determine if it's a new or default status
            object_type: "Batch", // Set the object type to "Batch"
            markForDelete: false,
            activated: statusToAdd.selected, // Default to false if not set
          },
        ],
      };

      //console.log(payload, "Payload for adding SASL Batch Status"); // Debugging

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addSASLBatchStatuses`; // API endpoint
      const response = await axios.post(url, payload);
      fetchBatchStatuses();
      if (response.data?.status === true || response.data?.status === "true") {
        //console.log("Batch status added successfully:", response.data);
props.setBatchStatus((prev) => !prev);
        // Update the state to mark the status as saved
        setBatchStatuses((prev) =>
          prev.map((status, i) =>
            i === index
              ? { ...status, id: response.data?.data?.id, isNew: false }
              : status
          )
        );
      } else {
        console.error("Failed to add Batch status:", response.data?.message);
        setError(response.data?.message || "Failed to add Batch status.");
      }
    } catch (error) {
      console.error("Error adding Batch status:", error);
      setError("An error occurred while adding the Batch status.");
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };

  // const handleNextClick = async () => {
  //   console.log("handleNextClick called");
  //   try {
  //     // Validate that at least one batch status is selected
  //     const isAnyStatusSelected = batchStatuses.filter(
  //       (status) => status.isUpdated
  //     );
  //     if (!isAnyStatusSelected.length) {
  //       console.log("No updates detected. Proceeding to the next step.");
  //       props.handleNext(); // Directly move to the next tab
  //       return;
  //     }
  //     if (batchStatuses.every((status) => !status.selected)) {
  //       setErrorMessage("Please enable at least one in toggle mode.");
  //       return;
  //     }

  //     // Prepare the payload for the API
  //     const payload = {
  //       sponsorId: 2, // Example sponsorId
  //       ecosystemId: 1, // Example ecosystemId
  //       batchStatuses: isAnyStatusSelected.map((status) => ({
  //         status_id: status.id, // ID of the batch status
  //         status_name: status.name, // Name of the batch status
  //         // status_type: status.isNew ? "New" : "Default", // Determine if it's a new or default status
  //         // object_type: "Batch", // Set the object type to "Batch"
  //         markForDelete: false, // Mark for deletion if needed
  //         activated: status.selected, // Activation state
  //         status_type: status.type, // Determine if it's a new or default status
  //         object_type: "Batch",
  //         newStatusName: status.newName,
  //       })),
  //       poStatuses: [],
  //       shipmentStatuses: [],
  //     };

  //     console.log(payload, "Payload for updating SASL Batch Statuses"); // Debugging

  //     const url = `${appUrl}/Pharma%20Contract%20Manufacturing/N1/sh1/Pharma%20Co/Admin/updateFGStatuses`; // API endpoint
  //     const response = await axios.post(url, payload);
  //     fetchBatchStatuses();

  //     if (response.data?.status === true || response.data?.status === "true") {
  //       console.log("Batch statuses updated successfully:", response.data);

  //       // Move to the next tab
  //       if (props.handleNext) {
  //         props.handleNext();
  //       }
  //     } else {
  //       console.error(
  //         "Failed to update batch statuses:",
  //         response.data?.message
  //       );
  //       setErrorMessage(
  //         response.data?.message || "Failed to update batch statuses."
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error updating batch statuses:", error);
  //     setErrorMessage("An error occurred while updating batch statuses.");
  //   }
  // };

  const handleSaveChanges = async () => {
    //console.log("handleNextClick called");
    try {
      // Validate that at least one batch status is selected
      const isAnyStatusSelected = batchStatuses.filter(
        (status) => status.isUpdated
      );
      if (!isAnyStatusSelected.length) {
        //console.log("No updates detected. Proceeding to the next step.");

        return;
      }
      if (batchStatuses.every((status) => !status.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }

      // Prepare the payload for the API
      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),
        batchStatuses: isAnyStatusSelected.map((status) => ({
          status_id: status.id, // ID of the batch status
          status_name: status.name, // Name of the batch status
          // status_type: status.isNew ? "New" : "Default", // Determine if it's a new or default status
          // object_type: "Batch", // Set the object type to "Batch"
          markForDelete: false, // Mark for deletion if needed
          activated: status.selected, // Activation state
          status_type: status.type, // Determine if it's a new or default status
          object_type: "Batch",
          newStatusName: status.newName,
        })),
        poStatuses: [],
        shipmentStatuses: [],
      };

      //console.log(payload, "Payload for updating SASL Batch Statuses"); // Debugging

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFGStatuses`; // API endpoint
      const response = await axios.post(url, payload);
      fetchBatchStatuses();

      if (response.data?.status === true || response.data?.status === "true") {
        //console.log("Batch statuses updated successfully:", response.data);
      } else {
        console.error(
          "Failed to update batch statuses:",
          response.data?.message
        );
        setErrorMessage(
          response.data?.message || "Failed to update batch statuses."
        );
      }
    } catch (error) {
      console.error("Error updating batch statuses:", error);
      setErrorMessage("An error occurred while updating batch statuses.");
    }
  };
  const handleDelete = async (index) => {
    try {
      const statusToDelete = batchStatuses[index]; // Get the status to delete
      if (statusToDelete.isNew) {
        setBatchStatuses((prev) => prev.filter((_, i) => i !== index));
        //console.log("New Batch status removed without API call.");
        return;
      }
      // Prepare the payload for the API
      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),
        batchStatuses: [
          {
            status_id: statusToDelete.id, // ID of the batch status
            status_name: statusToDelete.name, // Name of the batch status
            //  status_type: statusToDelete.isNew ? "New" : "Default", // Determine if it's a new or default status
            // object_type: "Batch", // Set the object type to "Batch"
            status_type: statusToDelete.type, // Determine if it's a new or default status
            object_type: "Batch",
            activated: statusToDelete.selected, // Current activation state
            markForDelete: true, // Mark the status for deletion
          },
        ],
        poStatuses: [],
        shipmentStatuses: [],
      };

      //console.log(payload, "Payload for deleting Batch Status"); // Debugging

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFGStatuses`; // API endpoint
      const response = await axios.post(url, payload);
    

      if (response.data?.status === true || response.data?.status === "true") {
        //console.log("Batch status deleted successfully:", response.data);
          fetchBatchStatuses();
props.setBatchStatus((prev) => !prev);
        // Update the state to remove the deleted status
        setBatchStatuses((prev) => prev.filter((_, i) => i !== index));
      } else {
        console.error("Failed to delete Batch status:", response.data?.message);
        setError(response.data?.message || "Failed to delete Batch status.");
      }
    } catch (error) {
      console.error("Error deleting Batch status:", error);
      setError("An error occurred while deleting the Batch status.");
    }
  };

  const handleToggle = (index) => {
    const updated = [...batchStatuses];
    updated[index].selected = !updated[index].selected;
    updated[index].isUpdated = true;
    setBatchStatuses(updated);
    setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    const updated = [...batchStatuses];
    updated[index].name = value;
    setBatchStatuses(updated);
    setIsUpdated(true);
  };

  // const handleDelete = (index) => {
  //   const updated = batchStatuses.filter((_, i) => i !== index);
  //   setBatchStatuses(updated);
  // };

  const handleAddStatus = () => {
    // const nextId = (batchStatuses.length + 1).toString().padStart(2, "0");
    setBatchStatuses([
      ...batchStatuses,
      {
        // id: nextId,
        name: "",
        selected: false,
        isNew: true,
      },
    ]);
  };
  const handleCancel = (index) => {
    const updatedBatchStatuses = batchStatuses.filter((_, i) => i !== index); // Remove the status at the given index
    setBatchStatuses(updatedBatchStatuses); // Update the state
    //console.log(updatedBatchStatuses, "Updated Batch Statuses after Cancel");
  };

  const handleResetChanges = () => {
    if (isUpdated) {
      fetchBatchStatuses(); // Only fetch if there are unsaved changes
      setIsUpdated(false);
      setErrorMessage("");
    }
  };
  return (
    <div
      className={classes.container}
      style={{ display: "flex", flexDirection: "column", gap: "24px" }}
    >
      {/* Table and Buttons Section */}
      <div style={{ display: "flex", gap: "40px", alignItems: "flex-start" }}>
        <Table className={`${classes.table} default-table-styles`}>
          <TableHead className="default-table-styles">
            <TableRow>
              <TableCell className={classes.headerCell}>Selection</TableCell>
              <TableCell className={classes.headerCell}>Batch Status</TableCell>
              <TableCell className={classes.headerCell}>
                Batch Status ID
              </TableCell>
              <TableCell className={classes.headerCell}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              // Show loading spinner when loading is true
              <TableRow>
                <TableCell colSpan={4}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : error ? (
              // Show error message when error exists
              <TableRow>
                <TableCell colSpan={4}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                      backgroundColor: "#ffecec",
                      color: "#b00020",
                      border: "1px solid #ff9999",
                    }}
                  >
                    <Typography>{error}</Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : batchStatuses.length === 0 ? (
              // Show "No Data" message when batchStatuses is empty
              <TableRow>
                <TableCell colSpan={4}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                      color: "#666",
                    }}
                  >
                    <Typography>No Batch Statuses Found</Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              // Render batch statuses when available
              batchStatuses.map((status, index) => (
                <TableRow key={status.id}>
                  <TableCell className={classes.bodyCell}>
                    <Switch
                      checked={status.selected}
                      onChange={() => handleToggle(index)}
                      classes={{ switchBase: classes.switchBase }}
                      disabled={!canEdit}
                    />
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {status.isNew ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <TextField
                          placeholder="Type Text Here"
                          value={status.name}
                          onChange={(e) =>
                            handleNameChange(index, e.target.value)
                          }
                          onBlur={(e) => {
                            const { value } = e.target;
                            // Trim leading and trailing spaces for string values
                            if (typeof value === "string" && value.trim() !== value) {
                              handleNameChange(index, value.trim());
                            }
                          }}
                          className={classes.textField}
                          variant="outlined"
                          inputProps={{
                            onBeforeInput: (e) => {
                              const allowedChars = /^[a-zA-Z0-9\s\-()]+$/;
                              if (!allowedChars.test(e.data)) {
                                e.preventDefault();
                              }
                            }
                          }}
                        />
                        <div className={classes.inlineActions}>
                          <IconButton
                            onClick={() => handleCancel(index)}
                            className={classes.iconBtn}
                          >
                            <CancelIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            onClick={() => addSASLBatchStatuses(index)}
                            className={classes.iconBtn}
                            disabled={
                              !batchStatuses[index].name?.trim() ||
                              batchStatuses.some(
                                (b, i) =>
                                  i !== index &&
                                  b.name?.trim().toLowerCase() === batchStatuses[index].name?.trim().toLowerCase()
                              ) || savingStates[index]
                            }
                          >
                            <SaveIcon fontSize="small" />
                          </IconButton>
                        </div>
                      </div>
                    ) : (
                      status.name
                    )}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {status.id}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {canEdit && (status.isNew == true ||
                      (status.type === "New" &&
                        status.lastUpdatedBy !== "support@schrocken.com")) && (
                      <IconButton
                        aria-label="delete"
                        onClick={() => handleDelete(index)}
                      >
                        <DeleteIcon className={classes.deleteIcon} />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <div
          className={classes.buttonContainer}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            marginTop: "0px",
          }}
        >
          <Button
            type="button"
            className={classes.saveButton}
            onClick={handleSaveChanges}
            disabled={!isUpdated || !canEdit}
            style={{
    
    opacity: !isUpdated || !canEdit ? 0.7 : 1, // Fade out when disabled
    color: "#fff", 
  }}
          >
            Save Selection
          </Button>
          <Button
            className={classes.resetChangesButton}
            type="button"
            onClick={handleResetChanges}
             disabled={!isUpdated || !canEdit} // or whatever your "no changes" condition is
  style={{
    opacity: !isUpdated || !canEdit ? 0.8 : 1, // Fade out when disabled
  }}
          >
            Reset Selection
          </Button>
        </div>
      </div>
      {errorMessage && (
        <div style={{ color: "red", marginTop: 10 }} className="error-message">
          {errorMessage}
        </div>
      )}
      {canEdit && (
        <Button
          variant="outlined"
          onClick={handleAddStatus}
          className={classes.addButton}
        >
          <span className={classes.addIconCircle}>+</span>
          Add New Batch Status
        </Button>
      )}
      {/* 
      <div className={classes.footer}>
        <Button
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          &lt; Back
        </Button>
        <StyledButton
          className={classes.saveButton}
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
        >
          Save & Next
        </StyledButton>
      </div> */}
    </div>
  );
};

export default BatchStatusTab;
